export const generateErrorMessageFromResponse = (err): string => {
	return err.response?.data?.error?.message ?
		String(err.response.data.error.message) :
		$.__('Uh oh, something went wrong. Please try again.');
};
